/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 13:32:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/SEOSetting/index.tsx
 */

import React from 'react';

import css from './css.module.less';

import { Input, TextArea } from '@/src/components/Antd';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { useDispatch, useSelector } from 'react-redux';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getSeoSetting,
  getSubmitStamp,
  getUuid,
  onCollapseOpen,
  onErrorChange,
  onSeoSettingChange,
} from '../slice';

import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import Slug from 'src/constrains/SlugInput';
import { useI18n } from 'src/hooks/useRouterChange';
import { validateSeoSetting } from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/tools';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
const SEOSettings = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, hideSlug } = props;

  const _d = useDispatch();

  const { title, description, urlSlug, slugValid } = data || {};

  const _u: { uuid: string; contentUuid: string } = useSelector(getUuid());
  const { uuid, contentUuid } = _u;
  const handleOnTitleChange = (title) => {
    _d(onSeoSettingChange({ title }));
  };

  const handleOnDesChange = (description) => {
    _d(onSeoSettingChange({ description }));
  };

  const handleSlugOnChange = ({ slug, valid }) => {
    _d(onSeoSettingChange({ urlSlug: slug, slugValid: valid }));
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('salesChannelContent.index.pageTitle')}>
          <Input
            maxLength={100}
            size='large'
            value={title}
            onChange={handleOnTitleChange}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.pageMetaDescription')}>
          <TextArea
            maxLength={500}
            value={description}
            onChange={handleOnDesChange}
          />
        </ItemWrapper>
        {!hideSlug && (
          <Slug
            containerClassName={css.slugContainer}
            value={urlSlug}
            displayDangerousNotice
            url={'portal/contentPage/slug/duplicate'}
            slugValid={slugValid}
            fixedParams={{
              contentUuid: contentUuid,
              pageUuid: uuid,
            }}
            onChange={handleSlugOnChange}
          />
        )}
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(SEOSettings, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.seoSetting,
  getContent: getSeoSetting,
  title: getI18nFromGeneral('general.hOCTitle.pageSEOSetting'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, _p) => {
    const { isPrimary } = _p;
    return validateSeoSetting(x, isPrimary);
  },
  getSubmitStamp,
});
